const translate = {
    global: {
        interestedTitle: 'Se interessou?',
        interestedSubTitle: 'Então não perca essa oportunidade',
        interestedCockpitConcept: 'Você no comando do seu negócio.',
        interestedSignup: 'Clique aqui e contrate',
        appDownloadAppleStoreAlt: 'Faça o download na AppStore',
        appDownloadGooglePlayAlt: 'Faça o download na Google Play',
        policyPrivacy: 'Política de privacidade',
        help: 'Ajuda',
        errorTitle: 'Aplicação indisponível',
        reloadPage: 'Atualizar página',
        pleaseEnterContact: 'Por favor entre em contato conosco.',
        loggedFromHub: 'Você está logado via HUB.',
        modalAppDownloadTitle: 'Toda experiência do Cockpit na palma da sua mão.',
        modalAppDownloadSubTitle1:
            'Atue em toda a jornada de compra e venda de veículos, com a melhor experiência e a melhor performance.',
        modalAppDownloadSubTitle2: 'Baixe já o app Cockpit',
        modalAppDownloadDownload: 'Baixar',
        offlineTitle: 'Ops! Sem conexão com a internet.',
        boundaryErrorText: 'Ops! Empacamos! Tente acessar novamente.',
    },
    webinput: {
        default: '',
        required: 'Preencha o campo obrigatório',
        email: 'Digite um e-mail válido',
        emailLogin: 'Digite um e-mail válido',
        date: 'Digite uma data válida',
        dateShort: 'Digite uma data simplificada válida',
        password: 'Digite todos critérios de senha válidos',
        passwordWeakened: 'Digite todos critérios de senha válidos',
        url: 'Digite uma url válida (ex.: https://www.webmotors.com.br)',
        time: 'Digite um horário válido',
        nameSurname: 'Digite um nome e sobrenome válido',
        plate: 'Digite uma placa de veículo válida',
        tel: 'Digite um telefone válido',
        zipcode: 'Digite um CEP válido',
        document: 'Digite um CPF válido',
        documentCompany: 'Digite um CNPJ válido',
        renavam: 'Digite um renavam válido',
        placeHolderSelect: 'Pesquisar',
    },
    utils: {
        status0: 'Erro não parametrizado',
        status400: 'Dados inválidos',
        status401: 'Acesso não autenticado.',
        status403: 'Acesso não autorizado. Verifique com o administrador da loja',
        status404: 'Não conseguimos encontrar o que você estava procurando, tente novamente em instantes.',
        status405: 'O método HTTP não está suportado',
        status407: 'Credencias de autenticação por proxy server inválida',
        status408: 'Conexão encerrada pelo servidor, por questão de desuso',
        status409: 'Conflito com o recurso que está no servidor',
        status411: 'Content-Length no server está indefinida',
        status412: 'Acesso negado ao recurso de destino',
        status413: 'Carga de requisição mais larga que os limites estabelecidos pelo servidor',
        status414: 'URI maior do que o servidor aceita interpretar',
        status415: 'Servidor se recusa a aceitar este formato de payload',
        status416: 'Servidor não pode atender ao Header Range solicitado',
        status417: 'Expectativa enviada no cabeçalho da requisição Expect não foi suprida',
        status500:
            'Ops! O Cockpit está em manutenção e nossa equipe já está atuando para resolver, fique tranquilo que já já voltamos.',
        status501: 'Ação indisponível, tente novamente em instantes.',
        status502: 'Sistema indisponível, por favor entre em contato conosco.',
        status503: 'Sistema indisponível, tente novamente em instantes.',
        status504: 'Ação indisponível, tente novamente.',
        status505: 'Versão HTTP não é suportada pelo servidor',
        status507: 'Servidor não suporta armazenar este dado',
        status508: 'Servidor finalizou a operação porque encontrou um loop infinito',
    },
    pageStatus: {
        load: 'Carregando...',
    },
    login: {
        labelPublicMenu: 'Login',
        labelPublicMenuSolutions: 'Soluções',
        heroTitle: 'Você no comando do seu negócio.',
        heroSubTitle:
            'Gerencie seus clientes, suas propostas, seus vendedores, seu estoque, suas faturas, seu plano e em breve ainda contrate as soluções online.',
        aboutTitle: 'Conheça o Cockpit',
        solutionsTitle: 'Soluções exclusivas do ',
        solutionsTitleComplement: 'Cockpit',
        solutionsDescription: 'Faça a gestão da sua loja de forma inteligente, otimizada e rentável.',
        solutionsMandalaAlt: 'Soluções Cockpit Webmotors',
        solutionsWatchVideo: 'Assistir ao vídeo',
        solutionsDocLabel: 'Conheça todos os detalhes',
        storeTitle: 'Store',
        storeTitleEnd: '.',
        storeDescription: 'Em breve, contrate todas essas soluções online, através da ',
        storeDescriptionComplement: ' dentro do Cockpit.',
        storeParagraph1: 'Veja todos os produtos e serviços que estão disponíveis para sua loja.',
        storeParagraph2: 'Aproveite essas soluções para ',
        storeParagraph3: 'vender muito mais.',
        appTitle: `E você ainda tem o `,
        appTitle2: 'Cockpit',
        appTitle3: ' na palma da sua mão.',
        appDescription:
            'Atue em toda a jornada de compra e venda de veículos, com a melhor experiência e a melhor performance.',
        appDownloadNow: 'Baixe já o app. :D',
        appPosterAlt: 'App Cockpit Webmotors',
        sectionLatinTitle: 'A solução mais completa para a gestão de lojas de veículos da América Latina. ',
        sectionLatinBullet1: '+14mil',
        sectionLatinBullet1Complement: 'lojas ativas',
        sectionLatinBullet2: '+46mil',
        sectionLatinBullet2Complement: 'usuários',
        sectionLatinBullet3: '10mil',
        sectionLatinBullet3Complement: 'Acessos por dia',
        sectionLatinDescriptionLegal: '',
        sectionLatinDescription: 'Construa a melhor experiência para os seus clientes com sua loja aberta 24/7.',
        resetPassword: 'Redefinir senha',
        formTitle: 'Acesse já o Cockpit',
        formTitleLogin: 'Acessar',
        formSubTitleLogin: 'Insira seu e-mail e senha:',
        solutionsWatchVideoCall: 'Confira as soluções:',
        metaDefaultDescripion:
            'Ecossistema de soluções para as lojas de todo o mercado brasileiro. Fornecendo informações para a tomada de decisões mais assertivas e lucrativas.',
        loginButton: 'Acessar o Cockpit',
        loginFrom: 'Você está acessando via ',
        password: 'Senha',
        email: 'E-mail',
        keepLogged: 'Manter conectado',
        passwordUpdateSuccess: 'Senha atualizada com sucesso',
        userNotAllowed: 'Nome de usuário e/ou senha inválido',
        forgotPasswordError:
            'Ops! Parece que algo deu errado. Sua conta será bloqueada após 5 tentativas de acesso sem sucesso. Revise seus dados ou ',
        forgotPasswordErrorLink: ' clique aqui para redefinir sua senha.',
        forgotPassworkTitle: 'Esqueci a senha',
        signupLinkText: 'Não tem uma conta ainda?',
        signupLink: ' Fale conosco'
    },
    header: {
        myProfile: 'Meu perfil',
        registrationData: 'Dados cadastrais',
        exit: 'Sair',
        allStores: 'Todas as lojas',
        selectStore: 'Selecionar loja',
        errorList: 'Erro de listagem',
        searchStore: 'Buscar por loja',
        select: 'Selecionar',
    },
    footer: {
        followUs: 'Siga a #Webmotors:',
        instagramAlt: 'Instagram da Webmotors',
        twitterAlt: 'Twitter da Webmotors',
        facebookAlt: 'Facebook da Webmotors',
        webmotorsBrands: 'Marcas Webmotors:',
        appStoreTitle: 'Baixe nosso app:',
        copyrights: 'Webmotors S.A. Todos os direitos reservados.',
    },
    cockpit: {
        labelPublicMenu: 'Cockpit',
    },
    crm: {
        labelPublicMenu: 'CRM',
    },
    inventory: {
        labelPublicMenu: 'Estoque',
    },
    autoguru: {
        labelPublicMenu: 'Autoguru',
    },
    moreFidelity: {
        labelPublicMenu: '+Fidelidade',
    },
    university: {
        labelPublicMenu: 'Universidade',
    },
    hotDeals: {
        labelPublicMenu: 'Feirões',
    },
    webmotorsTV: {
        labelPublicMenu: 'WebmotorsTV',
    },
    plans: {
        labelPublicMenu: 'Planos',
    },
    showroom: {
        labelPublicMenu: 'Showroom',
    },
    easySchedule: {
        labelPublicMenu: 'Agenda Fácil',
    },
    resale: {
        labelPublicMenu: 'Repasse',
    },
    pluginPro: {
        labelPublicMenu: 'PluginPRO',
    },
    vision360: {
        labelPublicMenu: 'Visão 360°',
    },
    rightPartnership: {
        labelPublicMenu: 'Parceria Certa',
    },
    integrator: {
        labelPublicMenu: 'Integrador',
    },
    surveyed: {
        labelPublicMenu: 'Vistoriado',
    },
    form: {
        buttonWait: 'Aguarde...',
    },
    storeGroup: {
        title: 'Selecionar loja',
        subtitle: 'Selecione a loja que gostaria de visualizar as informações.',
        selectStates: 'Selecionar por estado',
    },
};

export default translate;
